import React from "react";
import BaseComponent from "../baseComponent";
import SettingsComponent from "./settingsComponent";
import Utility, {dispatchAction} from "../../utility";
import {connect} from "react-redux";
import {history} from "../../managers/history";
import {eventConstants, pathConstants} from "../../constants";
import bannerService from "../../services/banner";

export class Banners extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        this.props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(bannerService.getGoldApi());
        this.props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err)
            return Utility.apiFailureToast("Unable to fetch Gold Price");
        this.setState({goldData: res, silverPrice: res.silver})
    }

    onAddNewAdvertiserClicked = () => {
        history.push(pathConstants.DASHBOARD_MENU.ADD_BANNERS);
    };

    render() {
        return (
            <SettingsComponent
                state={this.state}
                onAddNewAdvertiserClicked={this.onAddNewAdvertiserClicked}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default connect(mapStateToProps, {dispatchAction})(Banners);
